module.exports = __webpack_public_path__ + "media/stylesheets/images/main/eventImage/eventImage_mobile-f5d26cf4f83a06bd4c8d091163afc704.png";